import { HttpResponseBase } from '@angular/common/http'
import { ErrorHandler, Injectable } from '@angular/core'
import { AngularLoggerService } from './angularlogger.service'

@Injectable()
export class AngularErrorHandler extends ErrorHandler {
	constructor(private angularLoggerService: AngularLoggerService) {
		super()
	}

	handleError(error: HttpResponseBase) {
		const url = error.url ? new URL(error.url) : null
		if (!url || (url && !url.pathname.includes('/user/v2/login') && !url.pathname.includes('/user/sso/login') && !url.pathname.includes('/user/recovery-password') && !url.pathname.includes('/user/checkPasswordPar') && !url.pathname.includes('/user/setPassword'))) {
			this.angularLoggerService.logError(error)
		}
	}
}
